let ctx = null, loop = null, flash = null, title = null;

// iOS only allows audio after a user gesture: call this from a tap
export function unlockAudio() {
  try {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return;
    ctx = ctx || new C();
    if (ctx.state !== "running") ctx.resume();
    const s = ctx.createBufferSource();
    s.buffer = ctx.createBuffer(1, 1, 22050);
    s.connect(ctx.destination);
    s.start(0);
  } catch (e) { /* no audio */ }
}

function beep() {
  window.__cookAudioPlays = (window.__cookAudioPlays || 0) + 1;
  if (!ctx) return;
  if (ctx.state !== "running") ctx.resume();
  const t0 = ctx.currentTime;
  [0, 0.28, 0.56].forEach(o => {
    const osc = ctx.createOscillator(), g = ctx.createGain();
    osc.type = "square";
    osc.frequency.value = 880;
    g.gain.setValueAtTime(0.0001, t0 + o);
    g.gain.exponentialRampToValueAtTime(0.35, t0 + o + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + o + 0.2);
    osc.connect(g).connect(ctx.destination);
    osc.start(t0 + o);
    osc.stop(t0 + o + 0.22);
  });
}

export function startAlarm(label) {
  window.__cookAlarms = (window.__cookAlarms || 0) + 1;
  unlockAudio();
  stopSound();
  let n = 0;
  beep();
  loop = setInterval(() => (++n >= 25 ? stopSound() : beep()), 1400);
  if (navigator.vibrate) { navigator.vibrate([400, 200, 400, 200, 400]); window.__cookVibrated = (window.__cookVibrated || 0) + 1; }
  if (title === null) title = document.title;
  clearInterval(flash);
  let on = false;
  flash = setInterval(() => { on = !on; document.title = on ? `Tiden er gået! (${label})` : title; }, 900);
  document.title = `Tiden er gået! (${label})`;
}

function stopSound() { clearInterval(loop); loop = null; }

export function stopAlarm() {
  stopSound();
  clearInterval(flash); flash = null;
  if (title !== null) { document.title = title; title = null; }
  if (navigator.vibrate) navigator.vibrate(0);
}
